import script from "./ConsumerMypageProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerMypageProfileView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerMypageProfileView.vue?vue&type=style&index=0&id=5c5b9ec5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5b9ec5"]])

export default __exports__